import { supabase } from '../api/supabaseClient';
import type {
  ConsentRepository,
  RecordConsentParams,
  RecordConsentResult,
} from '../../application/ports/ConsentRepository';

const isProduction = process.env.REACT_APP_ENV === 'production';

/**
 * Supabase implementation of ConsentRepository
 * Only makes actual Supabase calls in production environment
 */
export const createSupabaseConsentRepository = (): ConsentRepository => ({
  recordConsent: async (params: RecordConsentParams): Promise<RecordConsentResult> => {
    if (!isProduction) {
      return {
        success: true,
        recordedDocuments: params.documents.map((doc) => doc.type),
        skippedDocuments: [],
      };
    }

    const { data, error } = await supabase.functions.invoke('record-consent', {
      body: params,
    });

    if (error) {
      const apm = (window as any).apm;
      if (apm && typeof apm.captureError === 'function') {
        apm.captureError(error);
      }
      throw error;
    }

    return data as RecordConsentResult;
  },
});
